import React from "react";
import { motion, AnimatePresence } from "framer-motion";

// Renders a small stack of animated rings behind its children — the assistant avatar in
// MissionChat, for example. Reacts to the voice conversation state:
//   idle      → no rings (hidden)
//   listening → cyan rings pulsing at "heartbeat" tempo (~1.6s)
//   thinking  → violet rings breathing slowly (~2.4s)
//   speaking  → fuchsia rings pulsing at "speech" tempo (~1.0s)
// Framer Motion drives the scale + opacity so the animation is silky even during React re-renders.
const TONES = {
    listening: { color: "border-meye-cyan/70",    glow: "rgba(34,211,238,0.55)",  duration: 1.6 },
    thinking:  { color: "border-violet-300/70",   glow: "rgba(167,139,250,0.5)",  duration: 2.4 },
    speaking:  { color: "border-meye-fuchsia/70", glow: "rgba(217,70,239,0.6)",   duration: 1.0 },
};

export const AperturePulseRing = ({ state = "idle", size = 22, children, testid }) => {
    const tone = TONES[state];
    // Rings sit ABSOLUTELY around the child so this component slots into any existing layout
    // without shifting sibling elements.
    return (
        <span
            className="relative inline-flex items-center justify-center"
            style={{ width: size, height: size }}
            data-testid={testid || "aperture-pulse-ring"}
            data-state={state}
        >
            <AnimatePresence>
                {tone && [0, 1].map((i) => (
                    <motion.span
                        key={`${state}-${i}`}
                        aria-hidden="true"
                        className={`absolute rounded-full border ${tone.color}`}
                        style={{
                            width: size,
                            height: size,
                            boxShadow: `0 0 12px ${tone.glow}`,
                        }}
                        initial={{ scale: 1, opacity: 0.6 }}
                        animate={{
                            scale: [1, 1.9 + i * 0.35, 1],
                            opacity: [0.55, 0, 0.55],
                        }}
                        exit={{ opacity: 0, scale: 1 }}
                        transition={{
                            duration: tone.duration,
                            repeat: Infinity,
                            delay: i * (tone.duration / 2),
                            ease: "easeOut",
                        }}
                    />
                ))}
            </AnimatePresence>
            <span className="relative inline-flex items-center justify-center">{children}</span>
        </span>
    );
};

export default AperturePulseRing;
